import { render, staticRenderFns } from "./TicketPriorityIndicator.vue?vue&type=template&id=288e1084&scoped=true&"
import script from "./TicketPriorityIndicator.vue?vue&type=script&lang=js&"
export * from "./TicketPriorityIndicator.vue?vue&type=script&lang=js&"
import style0 from "./TicketPriorityIndicator.vue?vue&type=style&index=0&id=288e1084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288e1084",
  null
  
)

export default component.exports